import type { CandidateFormData } from './CandidateFormFields';
import type { Candidate } from '../types/candidate.types';

export interface CandidateFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: 'create' | 'edit';
  candidate?: Candidate | null;
}

export const DEFAULT_VALUES: CandidateFormData = { name: '', email: '', country: null, phone: '' };

export function toFormValues(candidate: Candidate): CandidateFormData {
  return {
    name: candidate.name,
    email: candidate.email,
    country: candidate.country,
    phone: candidate.phone ?? '',
  };
}

export function buildPayload(
  data: CandidateFormData,
  country: string | null
): { name: string; email: string; country?: string; phone?: string } {
  return {
    name: data.name,
    email: data.email,
    country: country || undefined,
    phone: data.phone || undefined,
  };
}

export function getLabels(
  mode: 'create' | 'edit',
  isLoading: boolean
): { title: string; submitLabel: string } {
  const isCreate = mode === 'create';
  return {
    title: isCreate ? 'Add Candidate' : 'Edit Candidate',
    submitLabel: isCreate
      ? isLoading
        ? 'Creating...'
        : 'Create'
      : isLoading
        ? 'Saving...'
        : 'Save',
  };
}

export function resetFormState(
  reset: (values: CandidateFormData) => void,
  setCountry: (c: string | null) => void,
  mode: 'create' | 'edit',
  candidate?: Candidate | null
): void {
  if (mode === 'edit' && candidate) {
    reset(toFormValues(candidate));
    setCountry(candidate.country ?? null);
  } else if (mode === 'create') {
    reset(DEFAULT_VALUES);
    setCountry(null);
  }
}
